module.exports = __webpack_public_path__ + "img/logo-origin.b08b271f.svg";